"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceFields = void 0;
exports.insuranceFields = `
  id
  name
  organizationalNumber
`;
//# sourceMappingURL=insurance.js.map